import { render, staticRenderFns } from "./EditorialEdit.vue?vue&type=template&id=da8ab714&scoped=true&"
import script from "./EditorialEdit.vue?vue&type=script&lang=js&"
export * from "./EditorialEdit.vue?vue&type=script&lang=js&"
import style0 from "./EditorialEdit.vue?vue&type=style&index=0&id=da8ab714&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8ab714",
  null
  
)

export default component.exports